import { useLazyQuery } from '@apollo/client'
import { GET_BILLER_DISCOVERY_QUERY } from '../../../graphql/query/getBillerDiscovery.graphql'

export const useGetBillerDiscoveryService = () => {
  const [
    loadApi,
    {
      called = true,
      loading: gqlLoading = true,
      error: gqlError = null,
      data: gqlData = null
    }
  ] = useLazyQuery(GET_BILLER_DISCOVERY_QUERY)

  /**
   * when apollo client updates gqlData, gqlLoading or gqlError
   * trigger subsquent action or data processing.
   * for example: triggering routing change or clean up data
   */
  const { potentialPayeeListInquiry = {} } = gqlData || {}

  return {
    called,
    billerDiscoveryLoading: gqlLoading,
    dataBD: gqlData,
    billerDiscoveryError: gqlError?.graphQLErrors[0],
    payeeList: potentialPayeeListInquiry
      ? potentialPayeeListInquiry.payeeList
      : [],
    loadBillerDiscovery: loadApi
  }
}

export default useGetBillerDiscoveryService
